import { AppCard } from '@/layout/AppComponents';

export default function ModuleComsaEnvironmentalTitleCard(props) {
  const { color, children } = props;

  return (
    <AppCard className={`alert alert-${color}`}>
      {children}
    </AppCard>
  );
}
